var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 79,
    viewBox: "0 0 81 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2741 77.8523C50.5489 77.8523 60.4028 73.8217 67.6681 66.6472C74.9334 59.4727 79.015 49.7419 79.015 39.5956C79.015 29.4494 74.9334 19.7186 67.6681 12.5441C60.4028 5.36959 50.5489 1.33899 40.2741 1.33899C29.9994 1.33899 20.1455 5.36959 12.8802 12.5441C5.61482 19.7186 1.5332 29.4494 1.5332 39.5956C1.5332 49.7419 5.61482 59.4727 12.8802 66.6472C20.1455 73.8217 29.9994 77.8523 40.2741 77.8523V77.8523Z",
    stroke: "#ECF0F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3539 32.6934C31.9418 32.3268 31.456 32.0503 30.9282 31.8818C30.4005 31.7133 29.8427 31.6567 29.2913 31.7157C28.7399 31.7746 28.2072 31.9478 27.7283 32.224C27.2493 32.5001 26.8347 32.8729 26.5116 33.3181C26.3007 33.6025 26.0436 33.9326 25.7144 34.3414C24.6941 35.6117 24.1397 37.1859 24.1416 38.8072C24.1435 40.4286 24.7015 42.0015 25.7247 43.2695C27.283 45.1765 28.9159 47.1013 30.739 48.9042C32.5647 50.7071 34.5139 52.3195 36.4476 53.8558C39.0601 55.938 42.8607 55.938 45.4861 53.8685C45.9516 53.5003 46.3167 53.2286 46.6253 53.0051C48.4819 51.6669 48.7981 49.1556 47.2939 47.439C46.6023 46.661 45.8924 45.899 45.1647 45.1537C44.1773 44.1253 42.4801 44.011 41.395 44.9404C41.2073 45.1029 40.9656 45.3213 40.6287 45.6285C37.6279 43.8688 35.8073 42.0481 34.0561 39.1381C34.375 38.8029 34.5961 38.5592 34.7633 38.3712C35.2121 37.842 35.4392 37.1634 35.3981 36.4742C35.357 35.7851 35.0508 35.1375 34.5421 34.6639C33.8221 34.0011 33.097 33.3358 32.3539 32.6934V32.6934Z",
    stroke: "#103046",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6464 37.8836C47.3516 36.4199 46.5519 35.1025 45.3836 34.1559C44.1722 33.169 42.6413 32.6461 41.0713 32.6831",
    stroke: "#103046",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5838 36.5907C54.918 33.2883 53.1132 30.3161 50.4769 28.1805C47.7411 25.9505 44.2827 24.7695 40.7363 24.8541",
    stroke: "#103046",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIcon);
export default __webpack_public_path__ + "static/media/contact-us-icon.c01a1e3bcd3377394285b89ee0079e20.svg";
export { ForwardRef as ReactComponent };